import { render, staticRenderFns } from "./Pawiwahan.vue?vue&type=template&id=5bc21aac&scoped=true"
import script from "./Pawiwahan.vue?vue&type=script&lang=js"
export * from "./Pawiwahan.vue?vue&type=script&lang=js"
import style0 from "./Pawiwahan.vue?vue&type=style&index=0&id=5bc21aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc21aac",
  null
  
)

export default component.exports